import * as React from 'react';
import { connect } from 'react-redux';
import Moment from 'moment';
import {
  LocationWorkflowStepName,
} from './config';
import { UserInfo } from '../../../Login/common/defaults';
import Api from '../../../../services/Api';
import { ApiResponse } from 'apisauce';
import { getTableValuesByGroupName } from '../../../../services/Utils/IndexedDBUtils';
import { extendMoment } from 'moment-range';
import * as urls from '../../../shared/urls';
import LocationEntry from './LocationEntry';
import {
  IAppRouteLocation,
  IFormioValidationError,
  IWorkflowItemStep,
} from '../../../../common/sharedTypes';
import { QueueStartDate } from '../../common';
import { setShowHeader, setShowSidebar } from '../../../Application/redux-objects/actions';

const moment = extendMoment(Moment);

export interface ILocationEntryPopOutViewProps {
  setShowSidebar?: (showSidebar: boolean) => void;
  setShowHeader?: (showHeader: boolean) => void;
  endPoint: string;
  currentUser: UserInfo;
  history: any;
  assignWorkflowItem: (
    url: string,
    stepItemId: number,
    assignToId: number
  ) => Promise<any>;
  updateHeaderOnNav: (headerInfo: string) => void;
  openWorkflowItemStep?: IWorkflowItemStep;
}

export interface ILocationEntryPopOutViewState {
  data: any[];
  imageData: string;
  dropDownValue: number;
  startDate: Moment.Moment;
  endDate: Moment.Moment;
  focusedInput: any;
  countyData: any[];
  countyDropdownValue: string;
  filteredData: any[];
  showDataEntry: boolean;
  selectedItemId: number;
  formIsReadOnly: boolean;
  currentCrashId: any;
  imagePopup: boolean;
  workflowItemStepId: number;
  cellData: any;
  rowData: any;
  transcriberData: any[];
  jsonData: any[];
  workflowItemStepWorkflowItemId: number;
  enableContinue: boolean;
  showTValForm: boolean;
  showLRS: boolean;
  showLoadingNext: boolean;
  locationEntryDataToSave: any;
  locationEntryValidations: IFormioValidationError[];
  savingLocationData: boolean;
}

enum Districts {
  All = 0,
  One = 1,
  Two = 2,
  Three = 3,
  Four = 4,
  Five = 5,
  Six = 6,
}

class LocationEntryPopOutView extends React.Component<
  ILocationEntryPopOutViewProps,
  ILocationEntryPopOutViewState
> {
  
  dataEntry: any;
  windowRef: any;
  windowChild: any;
  
  constructor(props: ILocationEntryPopOutViewProps) {
    super(props);

    this.state = {
      data: [],
      imageData: '',
      dropDownValue: Districts.All,
      startDate: moment(QueueStartDate),
      endDate: moment(),
      focusedInput: null,
      countyData: null,
      countyDropdownValue: 'All',
      filteredData: [],
      showDataEntry: false,
      selectedItemId: null,
      formIsReadOnly: false,
      currentCrashId: '',
      imagePopup: false,
      workflowItemStepId: null,
      cellData: null,
      rowData: null,
      transcriberData: [],
      jsonData: [],
      workflowItemStepWorkflowItemId: null,
      enableContinue: false,
      showTValForm: false,
      showLRS: false,
      showLoadingNext: false,
      locationEntryDataToSave: null,
      locationEntryValidations: [],
      savingLocationData: false
    };

    if (this.state.countyData === null || this.state.countyData.length == 0)
      getTableValuesByGroupName('County').then((result) =>
        this.setState({ countyData: result })
      );
  }

  componentDidMount() {
    this.props.setShowSidebar(false);
    this.props.setShowHeader(false);
    const urlParams = new URLSearchParams(window.location.search);
    let reportId = urlParams.get('r');
    // let uri = urls.DOC_VIEWER_GET_ALL_DOCUMENTS + `?reportId=${reportId}&dbToSearch=${dbToSearch}`;
    // this.props.getAllDocuments(uri).then(() => {
    //   this.setState({ loading: false });
    // });
  }

  handleFocusChange = (focusedInput) => this.setState({ focusedInput });


  handleUpdateLocationData = (data: any) => {
    this.setState({ locationEntryDataToSave: data });
  }

  handleSave = () => {
    let allDataFromEntry = { data: this.state.locationEntryDataToSave, currentItemId: this.state.workflowItemStepId };
    const dataToSave = {
      spotMappedLocations: allDataFromEntry.data.spotMappedLocations,
      correctedData: allDataFromEntry.data.correctedData,
      workflowItemStepId: allDataFromEntry.currentItemId,
      currentUserId: this.props.currentUser.id,
      doComplete: false,
    };

    Api.post(urls.SAVE_DATA_FOR_LOCATION_DATA_ENTRY, dataToSave)
      .then((response: ApiResponse<any>) => {
        if (response.ok && response.data.saved) {
          console.log('saved location data', { dataToSave });
        }
      })
  }


  handleOpenInDataTranscriberValidation(
    event: React.MouseEvent<HTMLElement>,
    rowData: any,
    readonly?: any
  ) {
    event.preventDefault();
    this.openInDataTranscriberValidation(rowData, readonly);
  }

  getJsonData = async (workflowItemStepWorkflowItemId: number) => {
    const id = {
      id: workflowItemStepWorkflowItemId.toString(),
    };

    await Api.post(
      urls.GET_REPORT_VALIDATION_JSON_FOR_LOCATION,
      JSON.stringify(id)
    ).then((response: ApiResponse<any>) => {
      this.setState({ jsonData: response.data });
      return response.data;
    });
  };

  openInDataTranscriberValidation = (rowData: any, readonly: any = false) => {
    let location: IAppRouteLocation = {
      pathname: '/DataTranscriberValidation',
      key: 'absca',
    };

    let locationState: any = {};
    locationState.data = this.state.data;
    location.state = locationState;
    this.props.history.push(location, locationState);
  };


  render() {
 
    return (
      <React.Fragment>
       
            <LocationEntry
              ref={(comp) => {
                this.dataEntry = comp;
              }}
              currentQueueType={LocationWorkflowStepName.Review}
              setCrashId={(id) => this.setState({ currentCrashId: id })}
              itemToEdit={this.state.selectedItemId}
              webserviceUrl={this.props.endPoint.replace('/api/', '')}
              readOnly={this.state.formIsReadOnly}
              currentUserId={this.props.currentUser.id}
              userTypeId={4}
              setContinue={true}
              workflowItemStepId={this.state.workflowItemStepId}
              updateDataToSave={this.handleUpdateLocationData}
              validationErrors={this.state.locationEntryValidations}
            />
          
      </React.Fragment>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    currentUser: state.Application.currentUser,
  };
}

const mapDispatchToProps = {
  setShowSidebar,
  setShowHeader,  
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationEntryPopOutView);